import * as React from 'react';
import { throttle } from 'throttle-debounce';
import { Button } from '@cian/ui-kit/button';
import { EEstimationTargets } from '@cian/valuation-main-filters-widget';

import * as styles from './styles.css';

export type IValuationFiltersSubmitStoreProps = {
  buttonText: string;
  estimationTarget: EEstimationTargets;
};

export interface IValuationFiltersSubmitDispatchProps {
  handleValidate(params: { isValuationPollCheck: boolean }): Promise<boolean>;
  handleSubmit(): void;
}

export type TProps = IValuationFiltersSubmitStoreProps & IValuationFiltersSubmitDispatchProps;

/**
 * Расстояние от контейнера до края окна браузера
 */
const MAX_BOTTOM_OFFSET = 20;

export class ValuationFiltersSubmit extends React.Component<TProps> {
  private htmlContainer: HTMLDivElement | null = null;

  public componentDidMount() {
    if (this.htmlContainer) {
      this.changeShadow();

      document.addEventListener('scroll', this.handleScroll);
    }
  }

  public componentWillUnmount() {
    document.removeEventListener('scroll', this.handleScroll);
  }

  public render() {
    return (
      <div ref={ref => (this.htmlContainer = ref)} className={styles['container']}>
        <Button theme="fill_primary" onClick={this.handleSubmit} size="M">
          {this.props.buttonText}
        </Button>
      </div>
    );
  }

  private handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    const { handleSubmit, handleValidate } = this.props;

    const isValid = await handleValidate({
      isValuationPollCheck: false,
    });

    /**
     * Если валидация пройдена, опросник заполнен или не требует заполнения - идем за оценкой
     * */
    if (isValid) {
      return handleSubmit();
    }
  };

  private changeShadow = () => {
    if (this.htmlContainer) {
      const bottomOffset = window.innerHeight - this.htmlContainer.getBoundingClientRect().bottom;

      if (bottomOffset > MAX_BOTTOM_OFFSET) {
        this.htmlContainer.classList.remove(styles['shadow']);
      } else {
        this.htmlContainer.classList.add(styles['shadow']);
      }
    }
  };

  private handleScroll = throttle(200, this.changeShadow);
}
